export const IDLE = 'idle';
export const LOADING = 'loading';
export const SUCCEDED = 'succeded';
export const FAILED = 'failed';